import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useTournament } from '../components/TournamentContext';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import Spinner from '../components/Spinner';

const AdminRoute = ({ children }) => {
  const [authorized, setAuthorized] = useState(null); // null = loading
  const [redirectToLogin, setRedirectToLogin] = useState(false);
  const token = localStorage.getItem('token');
  const { tournament } = useTournament();

  useEffect(() => {
    const verifyAdmin = async () => {
      const isTokenValid = () => {
        if (!token) return false;
        try {
          const { exp } = jwtDecode(token);
          return Date.now() < exp * 1000;
        } catch (e) {
          return false;
        }
      };

      if (!tournament?._id) return;

      if (!isTokenValid()) {
        setRedirectToLogin(true); // redirect if token is bad
        return;
      }

      const cacheKey = `admin_check_${tournament._id}_${token}`;
      const cached = localStorage.getItem(cacheKey);

      if (cached !== null) {
        setAuthorized(cached === 'true');
        return;
      }

      try {
        const response = await axios.get(`/api/tournaments/${tournament._id}/admin-check`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const isAdmin = response.data.isAdmin === true;
        localStorage.setItem(cacheKey, isAdmin);
        setAuthorized(isAdmin);
      } catch (err) {
        console.error('Admin check failed:', err);
        localStorage.setItem(cacheKey, false);
        setAuthorized(false);
      }
    };

    verifyAdmin();
  }, [tournament?._id, token]);

  if (redirectToLogin) return <Navigate to="/auth/login" replace />;
  if (authorized === null) return <Spinner />;
  if (!authorized) return <Navigate to="/auth/unauthorized" replace />;

  return children;
};

export default AdminRoute;
